import Skeleton from 'react-loading-skeleton';
import { Card, CardBody, Col, Row } from 'reactstrap';

interface IProps {
  professionals: number;
  pendingActivities: number;
  exclusive: number;
  shared: number;
  loading?: boolean;
}

export const PendingActivitiesSummary = ({
  professionals,
  pendingActivities,
  exclusive,
  shared,
  loading = false,
}: IProps) => {
  const items = [
    {
      label: 'PROFISSIONAIS',
      value: professionals,
      icon: 'ri-user-3-fill',
    },
    {
      label: 'ATIVIDADES PENDENTES',
      value: pendingActivities,
      icon: 'ri-time-line',
    },
    {
      label: 'EXCLUSIVAS',
      value: exclusive,
      icon: 'ri-user-star-fill',
    },
    {
      label: 'COMPARTILHADAS',
      value: shared,
      icon: 'ri-group-fill',
    },
  ];

  return (
    <Card className="mt-3 mb-0">
      <CardBody className="p-0">
        <Row className="g-0">
          {items.map((item, index) => (
            <Col
              key={item.label}
              lg={3}
              md={6}
              sm={6}
              xs={12}
              className={`p-3 ${index !== items.length - 1 ? 'border-end' : ''}`}
            >
              <p
                className="mb-2 text-uppercase fw-semibold"
                style={{
                  color: '#7b8192',
                  fontSize: '0.95rem',
                  letterSpacing: '0.02em',
                }}
              >
                {item.label}
              </p>

              <div className="d-flex align-items-center gap-2">
                <i
                  className={item.icon}
                  style={{ color: '#7b8192', fontSize: '1.35rem' }}
                />
                {loading ? (
                  <Skeleton
                    width={64}
                    height={28}
                    baseColor="#e9ecef"
                    highlightColor="#f8f9fa"
                  />
                ) : (
                  <h3 className="mb-0 fw-semibold" style={{ color: '#495057' }}>
                    {item.value}
                  </h3>
                )}
              </div>
            </Col>
          ))}
        </Row>
      </CardBody>
    </Card>
  );
};
